import { Button, CircularProgress, Stack } from "@mui/material";
import { Elements, PaymentElement, useElements, useStripe } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { useEffect, useState } from "react";
import show from "../../../api/auth/orders/show";
import create from "../../../api/auth/orders/setupIntents/create";
import useOrderStore from "../../../stores/useOrderStore";
import useAlertStore from "../../../stores/useAlertStore";
import payLater from "../../../api/auth/orders/payLater";

const CardCollectionForm = ({ order, clientSecret, returnUrl, afterSuccess }) => {
  const stripe = useStripe();
  const elements = useElements();
  const [ submitting, setSubmitting ] = useState(false);

  const [errorMessage, setErrorMessage] = useState(null);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setSubmitting(true);

    if (elements == null) {
      return;
    }

    // Trigger form validation and wallet collection
    const {error: submitError} = await elements.submit();
    if (submitError) {
      // Show error to your customer
      setErrorMessage(submitError.message);
      return;
    }

    const {error} = await stripe.confirmSetup({
      //`Elements` instance that was used to create the Payment Element
      elements,
      clientSecret,
      confirmParams: {
        return_url: returnUrl || `http://localhost:3002/orders/${order.id}`,
      },
      redirect: 'if_required',
    });

    if (error) {
      // This point will only be reached if there is an immediate error when
      // confirming the payment. Show error to your customer (for example, payment
      // details incomplete)
      setErrorMessage(error.message);
      setSubmitting(false);
    } else {
      // Your customer will be redirected to your `return_url`. For some payment
      // methods like iDEAL, your customer will be redirected to an intermediate
      // site first to authorize the payment, then redirected to the `return_url`.
      show(order?.id, (response) => {
        setTimeout(() => {
          afterSuccess(response);
        }, 500);
      });
      setSubmitting(false);
    }
  };

  console.log(stripe, elements);

  return (
    <form onSubmit={handleSubmit}>
      <PaymentElement />
      <Stack direction="row" mt={2} width="100%" justifyContent="left">
        <Button width="220px" variant="contained" type="submit" disabled={!stripe || !elements || submitting}>
          Confirm and save card
        </Button>
      </Stack>
      {/* Show error message to your customers */}
      {errorMessage && <div>{errorMessage}</div>}
    </form>
  );
};

const CardCollection = ({ order, returnUrl, afterSuccess }) => {
  const [ clientSecret, setClientSecret ] = useState(null);
  const [ confirmAmount, setConfirmAmount ] = useState(null);
  const [ stateOrder, setStateOrder ] = useState(null);

  const { updateOrder } = useOrderStore();

  const { setAlertMessage } = useAlertStore();

  const onSubmit = () => {
    payLater(order.id, (response) => {
      updateOrder(response);
      afterSuccess(response);
      setAlertMessage("Order has been confirmed.", "success");
    });
  };

  useEffect(() => {
    show(order?.id, (response) => {
      setStateOrder(response);
    });
    create(order?.id, (response) => {
      setClientSecret(response.client_secret);
      setConfirmAmount(response.amount);
    });
  }, []);

  if(!stateOrder || !clientSecret) {
    return <CircularProgress />;
  }

  const stripePromise = loadStripe(stateOrder.stripe_publishable_key);

  const options = {
    clientSecret: clientSecret,
    // Fully customizable with appearance API.
    appearance: {
      /*...*/
    },
  };

  return (
    <Elements stripe={stripePromise} options={options}>
      <Stack direction="row" justifyContent="left" mb={3}>
        <Button variant="outlined" onClick={onSubmit}>Confirm without card</Button>
      </Stack>
      <CardCollectionForm order={order} clientSecret={clientSecret} returnUrl={returnUrl} confirmAmount={confirmAmount} afterSuccess={afterSuccess} />
    </Elements>
  );
};

export default CardCollection;